<template>
  <div class="container-fluid o-card" id="ehouse-double-calculating-result">
    <div class="row">
      <div class="es-xs-12">
        <h4
          class="u-color-primary u-margin-bottom u-padding-right-xsmall u-padding-left-xsmall"
        >
          E-House Double Room ({{ form.title || "" }})
          <Button
            v-if="!creatingPdf"
            variant="light-danger"
            size="sm"
            class="u-margin-left-small-sm-up u-margin-top-sm-down"
            @click="createPdf"
          >
            {{ $t("common.printCalculation") }}
          </Button>
          <Button
            v-if="!creatingPdf && !isDetail"
            variant="light-warning"
            size="sm"
            class="u-margin-left-small u-margin-top-sm-down"
            @click="$emit('reCalculate')"
          >
            {{ $t("common.reCalculate") }}
          </Button>
          <router-link
            v-if="!creatingPdf"
            :to="{ name: 'cycles-selection' }"
            class="u-display-inline-block"
          >
            <Button
              block
              variant="primary"
              class="u-margin-left-small-sm-up u-margin-top-sm-down"
            >
              {{ $t("cycles.selection2") }}
            </Button>
          </router-link>
        </h4>
        <div class="o-card o-card__padding-small u-margin-bottom">
          <div class="row">
            <!-- Sol Kolon - Giriş Verileri -->
            <div
              class="es-xs-12 u-font-size-xsmall"
              :class="{
                'es-sm-6': creatingPdf,
                'es-sm-3': !creatingPdf,
              }"
            >
              <div class="u-background-color-white">
                <h5 class="u-margin-bottom-small">
                  {{ $t("ehouseDoubleCalculating.designConditions") }}
                </h5>

                <h6 class="u-margin-bottom-xsmall">
                  {{ $t("ehouseDoubleCalculating.ambientConditions") }}
                </h6>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.altitudeLocation")
                  }}</span>
                  <span>{{ form.altitudeLocation }} m</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.ambientPressure")
                  }}</span>
                  <span>{{ form.ambientPressure }} kPa</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.ambientTemperature")
                  }}</span>
                  <span>{{ form.ambientTemperature }} °C</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.ambientRelativeHumidity")
                  }}</span>
                  <span>{{ form.ambientRelativeHumidity }} %</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.radiationPower")
                  }}</span>
                  <span>{{ form.solarRaditionPowerSquareMeter }} W/m²</span>
                </div>

                <h6 class="u-margin-bottom-xsmall u-margin-top-small">
                  {{ $t("ehouseDoubleCalculating.mainRoomAirConditions") }}
                </h6>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.airTemperature")
                  }}</span>
                  <span>{{ form.airTemperature }} °C</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.airRelativeHumidity")
                  }}</span>
                  <span>{{ form.airRelativeHumidity }} %</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.heatGeneration")
                  }}</span>
                  <span>{{ form.heatGeneration }} kW</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.pressurazingPressure")
                  }}</span>
                  <span>{{ form.pressurazingPressure }} Pa</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.requiredPressurization")
                  }}</span>
                  <span>{{ form.requiredPressurazing }} Pa</span>
                </div>
              </div>
            </div>
            <!-- Sol Kolon - Giriş Verileri -->
            <div
              class="es-xs-12 u-font-size-xsmall"
              :class="{
                'es-sm-6 ': creatingPdf,
                'es-sm-3 u-background-color-filtered o-card__padding-small':
                  !creatingPdf,
              }"
            >
              <h6 class="u-margin-bottom-xsmall u-margin-top-small">
                {{ $t("ehouseDoubleCalculating.auxiliaryRoomAirConditions") }}
              </h6>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.coolledAirRatio") }}</span>
                <span>{{ form.coolledAirRatio }} %</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.heatGeneration") }}</span>
                <span>{{ form.auxiliaryHeatGeneration }} kW</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{
                  $t("ehouseDoubleCalculating.requiredPressurization")
                }}</span>
                <span>{{ form.requiredPressurazing }} Pa</span>
              </div>

              <h6 class="u-margin-bottom-xsmall u-margin-top-small">
                {{ $t("ehouseDoubleCalculating.geometricParameters") }} ({{
                  $t("ehouseDoubleCalculating.mainRoom")
                }})
              </h6>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.length") }}</span>
                <span>{{ form.length }} mm</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.width") }}</span>
                <span>{{ form.width }} mm</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.height") }}</span>
                <span>{{ form.heigth }} mm</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.numberOfDoors") }}</span>
                <span>{{ form.numberOfDoors }} {{ $t("common.pcs") }}</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{
                  $t("ehouseDoubleCalculating.electricalInletOutlet")
                }}</span>
                <span
                  >{{ form.numberOfElectricalInletOutlet }}
                  {{ $t("common.pcs") }}</span
                >
              </div>

              <h6 class="u-margin-bottom-xsmall u-margin-top-small">
                {{ $t("ehouseDoubleCalculating.geometricParameters") }} ({{
                  $t("ehouseDoubleCalculating.auxiliaryRoom")
                }})
              </h6>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.length") }}</span>
                <span>{{ form.lengthAuxiliary }} mm</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.width") }}</span>
                <span>{{ form.widthAuxiliary }} mm</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{ $t("ehouseDoubleCalculating.height") }}</span>
                <span>{{ form.heigthAuxiliary }} mm</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{
                  $t("ehouseDoubleCalculating.adjecentWallLength")
                }}</span>
                <span>{{ form.adjecentWallLength }} mm</span>
              </div>
              <div
                class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
              >
                <span>{{
                  $t("ehouseDoubleCalculating.adjecentWallHeigth")
                }}</span>
                <span>{{ form.adjecentWallHeigth }} mm</span>
              </div>
            </div>

            <!-- Sağ Kolon - Hesaplama Sonuçları -->
            <div
              class="es-xs-12 u-font-size-xsmall"
              :class="{
                'es-sm-6': creatingPdf,
                'es-sm-3': !creatingPdf,
              }"
            >
              <div class="u-background-color-white">
                <h5 class="u-margin-bottom-small">
                  {{ $t("ehouseDoubleCalculating.calculationResults") }}
                </h5>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.heatGainMainRoomTransmission")
                  }}</span>
                  <span>{{ result.mainRoomSolarHeatGain.toFixed(2) }} kW</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.heatGainMainRoomRadiation")
                  }}</span>
                  <span
                    >{{ result.mainRoomRadiationHeatGain.toFixed(2) }} kW</span
                  >
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.heatGenerationMainRoom")
                  }}</span>
                  <span>{{ result.mainRoomHeatGeneration.toFixed(2) }} kW</span>
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t(
                      "ehouseDoubleCalculating.heatGainAuxiliaryRoomTransmission"
                    )
                  }}</span>
                  <span
                    >{{
                      result.auxiliaryRoomHeatGainWithoutSolar.toFixed(2)
                    }}
                    kW</span
                  >
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.heatGainAuxiliaryRoomRadiation")
                  }}</span>
                  <span
                    >{{ result.auxiliaryRoomSolarHeatGain.toFixed(2) }} kW</span
                  >
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.heatGenerationAuxiliaryRoom")
                  }}</span>
                  <span
                    >{{
                      result.auxiliaryRoomHeatGeneration.toFixed(2)
                    }}
                    kW</span
                  >
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.freshAirHeatGain")
                  }}</span>
                  <span>{{ result.totalThermalLoad.toFixed(2) }} kW</span>
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall u-font-weight-bold"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.heatGainCalculated")
                  }}</span>
                  <span
                    >{{ result.requiredCoolingCapacity.toFixed(2) }} kW</span
                  >
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{ $t("ehouseDoubleCalculating.safetyFactor") }}</span>
                  <span>{{ (result.safetyFactor * 100).toFixed(2) }} %</span>
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall u-font-weight-bold"
                >
                  <span>{{ $t("ehouseDoubleCalculating.heatGainTotal") }}</span>
                  <span
                    >{{
                      result.totalRequiredCoolingCapacity.toFixed(2)
                    }}
                    kW</span
                  >
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.airFlowMainRoom")
                  }}</span>
                  <span
                    >{{ result.mainRoomVolumetricFlow.toFixed(2) }} m³/h</span
                  >
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.airFlowAuxiliaryRoom")
                  }}</span>
                  <span
                    >{{
                      result.auxiliaryRoomVolumetricFlow.toFixed(2)
                    }}
                    m³/h</span
                  >
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.auxiliaryRoomTemperature")
                  }}</span>
                  <span
                    >{{
                      result.auxiliaryRoomAverageTemperature.toFixed(2)
                    }}
                    °C</span
                  >
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.airFlowInfiltration")
                  }}</span>
                  <span>{{ result.expectedAirLeakage.toFixed(2) }} m³/h</span>
                </div>

                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>{{
                    $t("ehouseDoubleCalculating.condensateWaterDrainage")
                  }}</span>
                  <span>{{ result.condensationAmount.toFixed(2) }} kg/h</span>
                </div>
                <div
                  class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                >
                  <span>E3</span>
                  <span>{{ result.calculatedE3.toFixed(2) }} kW</span>
                </div>
              </div>
            </div>
            <div
              class="es-xs-12 u-font-size-xsmall"
              :class="{
                'es-sm-6': creatingPdf,
                'es-sm-3': !creatingPdf,
              }"
            >
              <img
                src="@/assets/images/ehouse-sema.png"
                width="100%"
                alt="ehouse sema"
              />
              <div class="u-background-color-white">
                <div class="u-margin-top-small">
                  <h6 class="u-margin-bottom-xsmall">
                    {{
                      $t("ehouseDoubleCalculating.heatTransmissionCoefficients")
                    }}
                  </h6>
                  <div
                    class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                  >
                    <span>{{ $t("ehouseDoubleCalculating.walls") }}</span>
                    <span
                      >{{
                        result.averageWallHeatTransferCoefficient.toFixed(2)
                      }}
                      W/m²K</span
                    >
                  </div>
                  <div
                    class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                  >
                    <span>{{ $t("ehouseDoubleCalculating.floor") }}</span>
                    <span
                      >{{
                        result.groundHeatTransferCoefficient.toFixed(2)
                      }}
                      W/m²K</span
                    >
                  </div>
                  <div
                    class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                  >
                    <span>{{ $t("ehouseDoubleCalculating.ceiling") }}</span>
                    <span
                      >{{
                        result.ceilingHeatTransferCoefficient.toFixed(2)
                      }}
                      W/m²K</span
                    >
                  </div>
                  <div
                    class="u-display-flex u-justify-content-space-between u-align-items-center u-border-bottom u-padding-bottom-xxsmall u-margin-bottom-xxsmall"
                  >
                    <span>{{
                      $t("ehouseDoubleCalculating.adjacentWalls")
                    }}</span>
                    <span
                      >{{
                        result.adjacentWallHeatTransferCoefficient.toFixed(2)
                      }}
                      W/m²K</span
                    >
                  </div>
                </div>

                <div class="u-margin-top-small">
                  <i class="icofont-info-circle"></i>
                  {{ $t("ehouseDoubleCalculating.condensateWaterNote") }}
                </div>
              </div>
              <div v-if="!creatingPdf && !isDetail">
                <BaseInput
                  class="u-margin-top-small"
                  :label="$t('vincCalculating.title')"
                  v-model="title"
                  v-if="hasAuthorize.add"
                  block
                  disabled
                  size="sm"
                ></BaseInput>
                <Button
                  block
                  :disabled="!title"
                  v-if="hasAuthorize.add"
                  variant="primary"
                  class="u-margin-top"
                  @click="(e, l) => $emit('save', title, l)"
                >
                  {{ $t("common.save") }}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import Button from "@/components/Base/Button.vue";
import authorize from "./authorize";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";

export default {
  mixins: [authorize],
  components: {
    Button,
    BaseInput,
  },
  data() {
    return {
      title: "",
      creatingPdf: false,
    };
  },
  props: {
    result: {
      type: Object,
      default: () => ({}),
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async createPdfBlob() {
      const element = document.getElementById(
        "ehouse-double-calculating-result"
      );
      const opt = {
        margin: [25, 1, 40, 1],
        filename: "ehouse-double-calculating-result.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        },
      };

      const footerImg = "/pdf-footer.png";
      const headerImg = "/pdf-header.png";
      //const footerLogo = ;
      html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          var totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            // set footer to every page
            pdf.setPage(i);
            // set footer font
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.addImage(
              footerImg,
              "png",
              10,
              pdf.internal.pageSize.getHeight() - 30,
              pdf.internal.pageSize.getWidth() - 20,
              30
            );
            pdf.addImage(
              headerImg,
              "png",
              10,
              0,
              pdf.internal.pageSize.getWidth() - 20,
              25
            );
            // pdf.addImage(
            //   footerLogo,
            //   "png",
            //   0,
            //   0,
            //   pdf.internal.pageSize.getWidth(),
            //   0.3
            // );
          }
          window.open(pdf.output("bloburl"), "_blank");
          this.$store.dispatch("SET_ACTION_MODAL", {
            isLoading: false,
            status: false,
          });
          this.creatingPdf = false;
          this.$emit("pdfCreated");
        });
      return "";
    },
    blobToFile(blob, fileName) {
      return new File([blob], fileName, { type: "application/pdf" });
    },
    async createPdf() {
      this.creatingPdf = true;
      this.$store.dispatch("SET_ACTION_MODAL", {
        isLoading: true,
        status: true,
        message: this.$t("common.creatingPdf"),
        duration: 20 * 60 * 1000,
      });
      setTimeout(async () => {
        await this.createPdfBlob();
      }, 500);
    },
  },
};
</script>

<style scoped>
.u-border {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.u-border-bottom {
  border-bottom: 1px solid #e0e0e0;
}
</style>
